<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_tracking === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="ma-4">
          <div class="pa-3 pt-7">
            <v-divider/>
            <v-tabs grow show-arrows color="#8cc63e">
              <v-tab @click="page(0)" style="font-size: 18px">โปรโมชั่นแถมราคาถูกสุด</v-tab>
              <v-tab @click="page(1)" style="font-size: 18px">โปรโมชั่นราคาใหม่</v-tab>
            </v-tabs>
            <v-divider/>
          </div>
          <div class="pa-3">
            <div v-if="loading_data === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <div class="text-right">
                <router-link to="/promotionaddposfree" v-if="title_type === 0">
                  <v-btn x-large class="grad-success-bg white--text btn_mobile" style="font-size: 18px">จัดโปรโมชั่นแถมราคาถูกสุด</v-btn>
                </router-link>
                <router-link to="/promotionaddposprice" v-if="title_type === 1">
                  <v-btn x-large class="grad-success-bg white--text btn_mobile" style="font-size: 18px">จัดโปรโมชั่นราคาใหม่</v-btn>
                </router-link>
              </div>
              <v-card-title>
                <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="product_data" :footer-props="footer_Props" mobile-breakpoint="0" :search="search" >
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <td>{{ dataDetail.item.promotion_code }}</td>
                    <td>{{ dataDetail.item.promotion_title }}</td>
                    <td>
                        {{ dataDetail.item.promotion_buy }}
                    </td>
                    <td>{{ title_type == 0 ? dataDetail.item.promotion_free : dataDetail.item.promotion_price }}</td>
                    <td>
                      <div v-if="dataDetail.item.status == 1">
                        {{ dataDetail.item.date_start }} ถึง {{ dataDetail.item.date_stop }}
                      </div>
                      <div v-else style="color:#EC6061">
                        {{ dataDetail.item.date_start }} ถึง {{ dataDetail.item.date_stop }}
                      </div>
                    </td>
                    <td class="pa-3">
                      <v-switch v-model="dataDetail.item.status" @click="updateStatus(dataDetail.item.id, dataDetail.item.status)" color="success"></v-switch>
                    </td>
                    <td class="pa-3">
                      <v-btn v-if="title_type === 0" small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="getPromotionByID(dataDetail.item.id)" title="รายละเอียด">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                      <v-btn v-if="title_type === 1" small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="getPromotionByID(dataDetail.item.id)" title="รายละเอียด">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                      
                      <v-btn v-if="title_type === 0" small height="42" class="grad-warning-bg white--text mr-1 mb-1" @click="go_page_edit_free(dataDetail.item.id)" title="แก้ไขข้อมูล">
                        <v-icon>mdi-note-edit-outline</v-icon>
                      </v-btn>
                      <v-btn v-if="title_type === 1" small height="42" class="grad-warning-bg white--text mr-1 mb-1" @click="go_page_edit_price(dataDetail.item.id)" title="แก้ไขข้อมูล">
                        <v-icon>mdi-note-edit-outline</v-icon>
                      </v-btn>
                     
                      <v-btn small height="42" class="grad-danger-bg white--text mr-1 mb-1" @click="deletePromotion(dataDetail.item.id)" title="ลบข้อมูล">
                        <v-icon>mdi-delete-empty-outline</v-icon>
                      </v-btn>

                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>

        <!-- จัดส่ง -->
        <v-dialog v-model="detail_success" persistent max-width="900">
          <v-card class="">
            <v-form ref="update" @submit.prevent="wait_for_save">
              <div class="d-flex justify-space-between">
                <v-card-title class="bold pa-5">
                  รายละเอียด
                </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text class="pa-5">
                <v-row>
                  <v-col cols="12">
                    <div class="font-18 bold">ข้อมูลโปรโมชั่น</div>
                  </v-col>
                  <v-col cols="12" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">ชื่อโปรโมชั่น : </span> {{product_detail.promotion_title}} 
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">วันที่เริ่มต้นโปรโมชั่น : </span> {{product_detail.date_start}}
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">วันที่สิ้นสุดโปรโมชั่น : </span> {{product_detail.date_stop}}
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">จำนวนสินค้าที่ต้องซื้อ : </span> {{product_detail.promotion_buy}} ชิ้น
                    </div> 
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">จำนวนสินค้าที่แถม : </span> : {{product_detail.promotion_free}} ชิ้น
                    </div>
                  </v-col>
                  <v-col cols="12" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">รายละเอียด :  </span>
                    </div>
                  </v-col>
                  <v-col cols="12" class="py-1">
                    <div class="font-16">
                      {{product_detail.promotion_detail}}
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <div class="font-18 bold">สาขาที่ต้องการจัดโปรโมชั่น</div>
                  </v-col>
                  <v-col v-if="product_detail.type == 0" cols="12" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">ทุกสาขา</span>
                    </div>
                  </v-col>
                  <v-col v-if="product_detail.type == 1" cols="12" class="py-1">
                    <div class="font-16">
                      <span class="color-grey" v-for="(item, index) in product_detail.store_list" :key="index"> {{item.store_name+' '}}</span>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="mt-5">
                  <v-col cols="12" >
                    <div class="font-18 bold">สินค้าที่เข้าร่วมโปรโมชั่น</div>
                  </v-col>
                  <v-col cols="12" class="py-1">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              ชื่อสินค้า
                            </th>
                            <th class="text-center">
                              หน่วยนับ
                            </th>
                            <th class="text-center">
                              ราคา
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in product_detail.promotion_list" :key="item.id" >
                            <td>{{ item.product_name }}</td>
                            <td class="text-center">{{ item.unit_name }}</td>
                            <td class="text-center">{{ parseFloat(item.price) }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>

              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class=" grad-danger-bg white--text mr-3" @click="close_modal" style="font-size: 18px">
                  ปิด
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>

        <!-- จัดส่ง -->
        <v-dialog v-model="detail_price_success" persistent max-width="900">
          <v-card class="">
            <v-form ref="update" @submit.prevent="wait_for_save">
              <div class="d-flex justify-space-between">
                <v-card-title class="bold pa-5">
                  รายละเอียด
                </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text class="pa-5">
                <v-row>
                  <v-col cols="12">
                    <div class="font-18 bold">ข้อมูลโปรโมชั่น</div>
                  </v-col>
                  <v-col cols="12" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">ชื่อโปรโมชั่น : </span> {{product_detail.promotion_title}}
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">วันที่เริ่มต้นโปรโมชั่น : </span> {{product_detail.date_start}}
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">วันที่สิ้นสุดโปรโมชั่น : </span> {{product_detail.date_stop}}
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">จำนวนสินค้าที่ต้องซื้อ : </span> {{product_detail.promotion_buy}} ชิ้น
                    </div> 
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">ราคาโปรโมชั่น : </span> : {{product_detail.promotion_price}}
                    </div>
                  </v-col>
                  <v-col cols="12" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">รายละเอียด :  </span>
                    </div>
                  </v-col>
                  <v-col cols="12" class="py-1">
                    <div class="font-16">
                      {{product_detail.promotion_detail}}
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" >
                    <div class="font-18 bold">สาขาที่ต้องการจัดโปรโมชั่น</div>
                  </v-col>
                  <v-col v-if="product_detail.type == 1" cols="12" class="py-1">
                    <div class="font-16">
                      <span class="color-grey" v-for="(item, index) in product_detail.store_list" :key="index">{{item.store_name}}  </span>
                    </div>
                  </v-col>
                  <v-col v-if="product_detail.type == 0" cols="12" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">ทุกสาขา</span>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="mt-5">
                  <v-col cols="12" >
                    <div class="font-18 bold">สินค้าที่เข้าร่วมโปรโมชั่น</div>
                  </v-col>
                  <v-col cols="12" class="py-1">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              ชื่อสินค้า
                            </th>
                            <th class="text-center">
                              หน่วยนับ
                            </th>
                            <th class="text-center">
                              ราคา
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in product_detail.promotion_list" :key="index" >
                            <td>{{ item.product_name }}</td>
                            <td class="text-center">{{ item.unit_name }}</td>
                            <td class="text-center">{{ item.price }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>

              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class=" grad-danger-bg white--text mr-3" @click="close_modal" style="font-size: 18px">
                  ปิด
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
        
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
// import Swal from "sweetalert2";
// import {HTTP} from "@/axios";
import {formatPrice} from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Promotion_information",
  data() {
    return {
      loading_page: false,
      loading_data: false,
      detail_success: false,
      detail_price_success: false,
      overlay: false,
      alert_success: false,
      alert_tracking: false,
      title_type: 0,
      sortDesc:false,
      search: null,
      footer_Props: {
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [],
      data_list: [],
      data_test: [],
      product_data: [],
      product_detail: {},
      data_detail:[
        {
          product_name:'inj.GLUCOSE 20 CC for *INJection* 10.-',
          unit:'ชิ้น',
          price:'10.00',
        }, 
        {
          product_name:'ยาดม IZE JELLI BALM 7 G 29.-',
          unit:'ชิ้น',
          price:'25.00',
        }
      ]

    }
  },
  methods: {
     async deletePromotion(id) {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get(`/promotion/pharma/delete/${id}`, config).then((res) => {
        if (res.data.successful === true) {
          this.alert_success = true
          this.getPromotion_list()
          setTimeout(() => {this.alert_success = false}, 2000)
        }
      });
    },
     async getPromotion_list() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
        params: {
          page: 1,
          size: 10000,
          search: '',
        },
      };
      HTTP_ARIN.get(`/promotion/pharma/get/list/${this.title_type}`, config).then((res) => {
        if (res.data.successful === true) {
          this.product_data = res.data.data;
        }
      });
    },
     async getPromotionByID(id) {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get(`/promotion/pharma/get/by/${id}`, config).then((res) => {
        if (res.data.successful === true) {
          this.product_detail = res.data.data;
          if(this.title_type == 0){
            this.detail_free_modal()
          }else{
            this.detail_price_modal()
          }
        }
      });
    },
     async updateStatus(id, status) {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get(`/promotion/pharma/status/${id}?status=${status ? 1 : 0}`, config).then((res) => {
        if (res.data.successful === true) {
            this.getPromotion_list()
        }
      });
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    page(type) {
      this.title_type = type
      if (this.title_type === 0) {

          this.data_test = [
          {
            pro_code: 'pmt-00010',
            pro_name: 'โปรโมชั่นแถมสินค้าราคาถูกสุด ซื้อ 10 แถม 1',
            pro_qty: 10,
            pro_free: 1,
            pro_start_end: '01/12/2022 - 31/12/2022',
            status: 0
          },
          {
            pro_code: 'pmt-00009',
            pro_name: 'โปรโมชั่นแถมสินค้าราคาถูกสุด ซื้อ 9 แถม 1',
            pro_qty: 10,
            pro_free: 1,
            pro_start_end: '01/11/2022 - 31/11/2022',
            status: 1
          },
          {
            pro_code: 'pmt-00008',
            pro_name: 'โปรโมชั่นแถมสินค้าราคาถูกสุด ซื้อ 8 แถม 1',
            pro_qty: 10,
            pro_free: 1,
            pro_start_end: '01/11/2022 - 31/11/2022',
            status: 1
          },
        ],

        this.headers = [
          {
            text: 'รหัสโปรโมชั่น',
            value: 'pro_code',
            fixed: true,
            width: '200px',
          },
          {
            text: 'ชื่อโปรโมชั่น',
            value: 'pro_name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'จำนวนซื้อ',
            value: 'pro_qty',
            fixed: true,
            width: '150px',
          },
          {
            text: 'จำนวนแถม',
            value: 'pro_free',
            fixed: true,
            width: '150px',
          },
          {
            text: 'วันที่เริ่มต้น - สิ้นสุดโปรโมชั่น',
            value: 'pro_start_end',
            fixed: true,
            width: '250px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            fixed: true,
            width: '150px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          }
        ]
      }else{

        this.data_test = [
          {
            pro_code: 'pmt-00010',
            pro_name: 'โปรโมชั่นแถมสินค้าราคาถูกสุด ซื้อ 10 แถม 1',
            pro_qty: 10,
            pro_free: '100.00',
            pro_start_end: '01/12/2022 - 31/12/2022',
            status: 0
          },
          {
            pro_code: 'pmt-00009',
            pro_name: 'โปรโมชั่นแถมสินค้าราคาถูกสุด ซื้อ 9 แถม 1',
            pro_qty: 10,
            pro_free: '120.00',
            pro_start_end: '01/11/2022 - 31/11/2022',
            status: 1
          },
          {
            pro_code: 'pmt-00008',
            pro_name: 'โปรโมชั่นแถมสินค้าราคาถูกสุด ซื้อ 8 แถม 1',
            pro_qty: 10,
            pro_free: '140.00',
            pro_start_end: '01/11/2022 - 31/11/2022',
            status: 1
          },
        ],

        this.headers = [
          {
            text: 'รหัสโปรโมชั่น',
            value: 'pro_code',
            fixed: true,
            width: '200px',
          },
          {
            text: 'ชื่อโปรโมชั่น',
            value: 'pro_name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'จำนวนซื้อ',
            value: 'pro_qty',
            fixed: true,
            width: '150px',
          },
          {
            text: 'ราคา',
            value: 'pro_price',
            fixed: true,
            width: '150px',
          },
          {
            text: 'วันที่เริ่มต้น - สิ้นสุดโปรโมชั่น',
            value: 'pro_start_end',
            fixed: true,
            width: '250px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            fixed: true,
            width: '150px',
          },
          {
            text: 'จัดการ',
            value: 'tool',
            sortable: false,
            fixed: true,
            width: '200px',
          }
        ]
      }
      this.getPromotion_list()
    },
    detail_free_modal() {
      this.detail_success = true
    },
    detail_price_modal() {
      this.detail_price_success = true
    },
    go_page_edit_free(id) {
      this.$router.push('promotioneditposfree?id='+id)
    },
    go_page_edit_price(id) {
      this.$router.push('promotioneditposprice?id='+id)
    },
    close_modal() {
      this.detail_success = false
      this.detail_price_success = false
    },
  },
  mounted() {
    // page(0) ตั้งค่าแท็ป + headers แล้วเรียก getPromotion_list() อยู่แล้ว
    this.page(0)
  }
}
</script>

<style scoped>

.bold{
  font-weight: bold;
}

.font-18{
  font-size: 18px;
}

.font-16{
  font-size: 16px;
}

.color-grey{
  color: #909090;
}

</style>
